import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import KioskModal from './KioskModal';

const INACTIVITY_TIME = 180000; // 3 минуты

const InactivityModal = () => {
  const { t } = useTranslation();
  const [isInactive, setIsInactive] = useState(false);
  const [countdown, setCountdown] = useState(10);
  const navigate = useNavigate();
  const inactivityTimerRef = useRef(null);

  // Сброс таймера бездействия при активности пользователя
  const resetInactivityTimer = () => {
    clearTimeout(inactivityTimerRef.current);
    inactivityTimerRef.current = setTimeout(() => {
      setIsInactive(true);
    }, INACTIVITY_TIME);
  };

  // Подтверждение активности пользователем
  const handleConfirm = () => {
    setIsInactive(false);
    setCountdown(10);
    resetInactivityTimer();
  };

  useEffect(() => {
    resetInactivityTimer();

    const handleActivity = () => resetInactivityTimer();
    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keydown', handleActivity);
    window.addEventListener('touchstart', handleActivity);

    return () => {
      clearTimeout(inactivityTimerRef.current);
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keydown', handleActivity);
      window.removeEventListener('touchstart', handleActivity);
    };
  }, []);

  // Обратный отсчет в модальном окне
  useEffect(() => {
    if (!isInactive) return;

    const countdownTimer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(countdownTimer);
          navigate('/');
          setIsInactive(false);
          return 10;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(countdownTimer);
  }, [isInactive, navigate]);

  return (
    <AnimatePresence>
      {isInactive && (
        <KioskModal
          tone="accent"
          // системные модалки должны перекрывать модалки экранов (те на z-50)
          zClass="z-[60]"
          title={t('inactivityModal.title')}
          description={t('inactivityModal.redirect', { count: countdown })}
          descriptionKey={countdown}
          icon={
            <svg
              className="w-[5.4vh] h-[5.4vh]"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="9" />
              <path d="M12 7v5l3 3" />
            </svg>
          }
          footer={
            <button
              type="button"
              onClick={handleConfirm}
              className="w-full py-[2.2vh] rounded-[3vh] bg-[#246CE2] text-[2.2vh] font-bold text-white active:bg-[#1B55B4] transition-colors"
            >
              {t('inactivityModal.confirm')}
            </button>
          }
        />
      )}
    </AnimatePresence>
  );
};

export default InactivityModal;
